var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "46.000000pt",
    height: "43.000000pt",
    viewBox: "0 0 46.000000 43.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,43.000000) scale(0.100000,-0.100000)",
    fill: "#000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 416 c-159 -57 -198 -250 -71 -354 90 -74 219 -69 302 11 63 60 81 124 57 204 -34 114 -171 180 -288 139z m144 -21 c83 -30 129 -92 129 -176 0 -154 -184 -243 -314 -152 -47 33 -86 101 -86 152 0 76 56 148 139 177 48 17 80 17 132 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 292 c-32 -34 -34 -70 -6 -106 24 -31 102 -86 121 -86 7 0 36 15 64 34 85 57 102 128 42 170 -30 21 -50 20 -80 -3 -23 -19 -24 -19 -48 0 -35 26 -62 24 -93 -9z",
    fill: "#ff0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerce);
export default __webpack_public_path__ + "static/media/serce.700751bc816863b1dbdcaec9d3206bfb.svg";
export { ForwardRef as ReactComponent };